module.exports = "/assets/9aaf362abf4c75185395412b7a76dcb1.svg";